module.exports = {
    dateTimeFormats: {
        "de": {
            short: {
                year: "numeric", month: "numeric", day: "numeric"
            },
            long: {
                year: "numeric", month: "short", day: "numeric",
                weekday: "short", hour: "numeric", minute: "numeric"
            }
        },
        "en": {
            short: {
                year: "numeric", month: "numeric", day: "numeric"
            },
            long: {
                year: "numeric", month: "short", day: "numeric",
                weekday: "short", hour: "numeric", minute: "numeric"
            }
        },
        "fr": {
            short: {
                year: "numeric", month: "numeric", day: "numeric"
            },
            long: {
                year: "numeric", month: "short", day: "numeric",
                weekday: "short", hour: "numeric", minute: "numeric"
            }
        }
    }
}